import { sessionKeys, Views } from 'components/Enums';

export interface Itypes {
  product: Views;
  customer: Views;
  plugin: Views;
  connector: Views;
  integration: Views;
  feature: Views;
}
export interface IDefaultUrl {
  product: string;
  customer: string;
  plugin: string;
  connector: string;
  integration: string;
  feature: string;
  campaign: string;
}

export const defaultType = {
  product: Views.cardView,
  customer: Views.cardView,
  plugin: Views.cardView,
  connector: Views.cardView,
  integration: Views.cardView,
  feature: Views.cardView,
  campaign: Views.cardView,
};

export const defaultURL = {
  product: '/products',
  customer: '/customers',
  plugin: '/plugins',
  connector: '/connectors',
  integration: '/integrations',
  feature: '/features',
  campaign: '/campaigns',
};

export const updateSessionStorage = (key: string, value: string) => {
  const viewModes = JSON.parse(
    sessionStorage.getItem(sessionKeys.viewTypes) || JSON.stringify(defaultType)
  ) as Itypes;
  sessionStorage.setItem(
    'viewModes',
    JSON.stringify({ ...viewModes, [key]: value })
  );
};

export const getSessionStorageObject = (key: string) => {
  const viewModes = JSON.parse(
    sessionStorage.getItem(sessionKeys.viewTypes) || JSON.stringify(defaultType)
  ) as Itypes;
  return viewModes[key as keyof Itypes];
};
